import React, { Component, type ErrorInfo, type ReactNode } from "react";
import { safeCaptureException } from "@/utils/sentry";
import SomethingWentWrong from "@/components/ErrorComponent/SomethingWentWrong/SomethingWentWrong";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    safeCaptureException(error, {
      contexts: {
        react: {
          componentStack: errorInfo.componentStack,
        },
      },
    });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="h-full flex justify-center items-center ">
          <div className="mb-[52px]">
            <SomethingWentWrong />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
